import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Refresh reasons for orders values and config
 */
export const refreshReasonsForNotCompletedOrdersSettings = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/refreshReasonsForNotCompletedOrdersSettings', async (_params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/territory/refreshReasonsForNotCompletedOrdersSettings', {
      category: 'rpc',
      type: 'rpc/territory/refreshReasonsForNotCompletedOrdersSettings',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {refreshReasonsForNotCompletedOrdersSettings}`,
      { tags: ['rpc', 'territory'], info: error },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update of reasons for not completed orders failed`,
      error,
    })
  }
})
